import './footer.css';
import Image from "react-bootstrap/Image";

const Footer = () => {
	const languages = {
		bg: {
			disclaimer: "Подкрепата на Европейската комисия за изготвянето на настоящата публикация не представлява одобрение на съдържанието, което отразява гледните точки само на авторите и не може да се търси отговорност от Комисията за всяка употреба, която може да бъде използвана за информацията, съдържаща се в нея."
		},
		cs: {
			disclaimer: "Podpora Evropské komise při tvorbě této publikace nepředstavuje souhlas s obsahem, který odráží pouze názory autorů, a Komise nemůže být zodpovědná za jakékoliv využití informací obsažených v této publikaci."
		},
		da: {
			disclaimer: "Europa-Kommissionens støtte til produktionen af denne publikation udgør ikke en godkendelse af indholdet, som kun afspejler forfatternes egne synspunkter, og Kommissionen kan ikke holdes ansvarlig for den brug, der måtte blive gjort af de deri indeholdte oplysninger."
		},
		de: {
			disclaimer: "Die Unterstützung der Europäischen Kommission für die Erstellung dieser Veröffentlichung stellt keine Billigung des Inhalts dar, welcher nur die Ansichten der Verfasser wiedergibt, und die Kommission kann nicht für eine etwaige Verwendung der darin enthaltenen Informationen haftbar gemacht werden."
		},
		el: {
			disclaimer: "Η υποστήριξη της Ευρωπαϊκής Επιτροπής στην παραγωγή της παρούσας έκδοσης δεν συνιστά αποδοχή του περιεχομένου, το οποίο αντικατοπτρίζει αποκλειστικά τις απόψεις των συντακτών, και η Επιτροπή δεν μπορεί να αναλάβει την ευθύνη για οποιαδήποτε χρήση των πληροφοριών που περιέχονται σε αυτήν."
		},
		en: {
			disclaimer: "The European Commission's support for the production of this publication does not constitute an endorsement of the contents, which reflect the views only of the authors, and the Commission cannot be held responsible for any use which may be made of the information contained therein."
		},
		es: {
			disclaimer: "El apoyo de la Comisión Europea para la producción de esta publicación no constituye una aprobación del contenido, el cual refleja únicamente las opiniones de los autores, y la Comisión no se hace responsable del uso que pueda hacerse de la información contenida en la misma."
		},
		et: {
			disclaimer: "Euroopa Komisjoni toetus käesoleva väljaande koostamisele ei tähenda väljaandes esitatud sisu kinnitamist. Väljaandes esitatud sisu peegeldab vaid autorite seisukohti. Euroopa Komisjon ei vastuta selles sisalduva teabe kasutamise eest."
		},
		fi: {
			disclaimer: "Euroopan komission tuki tämän julkaisun tuottamiseen ei tarkoita sitä, että sisältö, joka kuvastaa pelkästään tekijöiden näkemyksiä, saa kannatusta, eikä komissiota voida saattaa vastuuseen niiden sisältämien tietojen mahdollisesta käytöstä."
		},
		fr: {
			disclaimer: "Le soutien de la Commission européenne à la production de cette publication ne constitue pas une approbation du contenu, qui reflète uniquement le point de vue des auteurs, et la Commission ne peut pas être tenue responsable de toute utilisation qui pourrait être faite des informations qu’elle contient."
		},
		ga: {
			disclaimer: "Ní hionann tacaíocht an Choimisiúin Eorpaigh do tháirgeadh an fhoilseacháin seo agus formhuiniú ar ábhair an fhoilseacháin, lena léirítear tuairimí na n-údar amháin, agus ní féidir freagracht a chur ar an gCoimisiún as aon úsáid a d’fhéadfaí a bhaint as an bhfaisnéis atá ann."
		},
		hr: {
			disclaimer: "Potpora Europske komisije proizvodnji ove publikacije ne predstavlja potporu sadržaju koji odražava samo stavove autora i Komisija ne može biti odgovorna za uporabu sadržanih informacija."
		},
		hu: {
			disclaimer: "Az Európai Bizottság támogatása ezen kiadvány elkészítéséhez nem jelenti a tartalom jóváhagyását, amely kizárólag a szerzők álláspontját tükrözi, valamint a Bizottság nem tehető felelőssé ezen információk bárminemű felhasználásáért."
		},
		it: {
			disclaimer: "Il sostegno della Commissione europea alla produzione di questa pubblicazione non costituisce un'approvazione del contenuto, che riflette esclusivamente il punto di vista degli autori, e la Commissione non può essere ritenuta responsabile per l'uso che può essere fatto delle informazioni ivi contenute."
		},
		lt: {
			disclaimer: "Europos Komisijos parama šio leidinio rengimui nereiškia pritarimo jo turiniui, kuriame pateikiama autorių nuomonė, todėl Europos Komisija negali būti laikoma atsakinga už informaciją panaudotą šiame leidinyje."
		},
		lv: {
			disclaimer: "Eiropas Komisijas atbalsts šīs publikācijas sagatavošanai nav uzskatāms par satura apstiprinājumu, kas atspoguļo tikai autoru viedokļus, un Komisija nevar būt atbildīga par tajā ietvertās informācijas jebkādu izmantošanu."
		},
		mt: {
			disclaimer: "L-appoġġ tal-Kummissjoni Ewropea għall-produzzjoni ta’ din il-pubblikazzjoni ma jikkostitwixxix approvazzjoni tal-kontenut, li jirrifletti biss il-fehmiet tal-awturi, u l-Kummissjoni ma tistax tinżamm responsabbli għal kwalunkwe użu li jista’ jsir mill-informazzjoni li tinsab fiha."
		},
		nl: {
			disclaimer: "De steun van de Europese Commissie voor de productie van deze publicatie houdt geen goedkeuring van de inhoud in. De inhoud geeft de standpunten van de auteurs weer en de Commissie kan niet aansprakelijk worden gesteld voor het gebruik dat eventueel wordt gemaakt van de daarin opgenomen informatie."
		},
		pl: {
			disclaimer: "Wsparcie Komisji Europejskiej dla produkcji tej publikacji nie stanowi poparcia dla treści, które odzwierciedlają jedynie poglądy autorów, a Komisja nie może zostać pociagnięta do odpowiedzialności za jakiekolwiek wykorzystanie informacji w niej zawartych."
		},
		pt: {
			disclaimer: "O apoio da Comissão Europeia à produção desta publicação não constitui um aval do seu conteúdo, que reflete unicamente o ponto de vista dos autores, e a Comissão não pode ser considerada responsável por eventuais utilizações que possam ser feitas com as informações nela contidas."
		},
		ro: {
			disclaimer: "Sprijinul acordat de Comisia Europeană pentru elaborarea acestei publicații nu constituie o aprobare a conținutului, care reflectă doar opiniile autorilor, iar Comisia nu poate fi trasă la răspundere pentru orice utilizare a informațiilor conținute în aceasta."
		},
		sk: {
			disclaimer: "Podpora Európskej komisie na výrobu tejto publikácie nepredstavuje súhlas s obsahom, ktorý odráža len názory autorov, a Komisia nemôže byť zodpovedná za prípadné použitie informácií, ktoré sú v nej obsiahnuté."
		},
		sl: {
			disclaimer: "Podpora Evropske komisije za pripravo te publikacije ne pomeni potrditve vsebine, ki izraža le mnenja avtorjev, in Komisija ne more biti odgovorna za kakršno koli uporabo informacij, ki jih vsebuje."
		},
		sv: {
			disclaimer: "Europeiska Kommissionens stöd åt framställningen av detta dokument utgör inte ett godkännande av dess innehåll, vilket endast återspeglar upphovsmännens åsikter, och Kommissionen kan inte hållas ansvarigt för någon användning av informationen i det."
		}
	}

	const storedLanguage = localStorage.getItem('i18n');
	let selectedLanguage;
	if (storedLanguage) {
		console.log("Language is already stored...",storedLanguage);
		selectedLanguage = languages[storedLanguage].disclaimer;
	} else {
		let browserLanguage;
		browserLanguage = navigator.language;
		//browserLanguage = "unknown"; //for testing
		console.log("No stored language found - I will detect it.....",browserLanguage);
		if (browserLanguage.includes("en")) {
			selectedLanguage = languages["en"].disclaimer;
		} else {
			if (languages[browserLanguage]) {
				selectedLanguage = languages[browserLanguage].disclaimer;
			} else {
				selectedLanguage = languages["en"].disclaimer;
			}
		}
	}

	return (
	<div className="lykioccs-footer-container">
		<ul className="lykioccs-footer-items">
			<li className="lykioccs-eu-logo-disclaimer">
				<div className="lykioccs-eu-logo-disclaimer-div">
					<div>
						<Image
							className="lykioccs-footer-small-logos"
							src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/eu_logo.png"
							alt="eu logo"
						/>
					</div>
					<div className="lykioccs-eu-logo-disclaimer-text">{selectedLanguage}</div>
				</div>
			</li>
			<li>
				<Image
					className="lykioccs-footer-large-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/inova_logo_cmyk.jpg"
					alt="inova logo"
				/>
			</li>
			<li>
				<Image
					className="lykioccs-footer-small-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/ccs_logo_transparent.png"
					alt="ccs logo"
				/>
			</li>					
			<li>
				<Image
					className="lykioccs-footer-small-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/bicc_logo.png"
					alt="bicc logo"
				/>
			</li>
			<li>
				<Image
					className="lykioccs-footer-large-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/ied_logo.png"
					alt="ied logo"
				/>
			</li>
			<li>
				<Image
					className="lykioccs-footer-large-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/logo_eseniors.png"
					alt="logo eseniors"
				/>
			</li>
			<li>
				<Image
					className="lykioccs-footer-large-logos"
					src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/mindful_ageing/images/partners/vamk_logo.png"
					alt="vamk_logo"
				/>
			</li>															
		</ul>
	</div>
	);
};
export default Footer;
